import styled from 'styled-components';

export const StyledButton = styled.div`
  align-items: center;
  appearance: none;
  background: ${props => props.theme.themeColors.zoomButtons.background};
  border-radius: 3px;
  border: 1px solid ${props => props.theme.themeColors.zoomButtons.borderColor};
  box-shadow: ${props => props.theme.themeColors.zoomButtons.boxShadow};
  cursor: pointer;
  display: flex;
  font-size: 1rem;
  height: 48px;
  justify-content: center;
  transition: all 0.15s ease;
  width: 48px;

  @media all and (max-width: 1200px) {
    width: 37px;
    height: 39px;
    border-radius: 10px;
    background: #F4F4F4;
  }

  &:hover {
    background: ${props =>
      props.theme.themeColors.zoomButtons.backgroundOnHover};
    border: 1px solid
      ${props => props.theme.themeColors.zoomButtons.borderColorOnHover};
    box-shadow: ${props =>
      props.theme.themeColors.zoomButtons.boxShadowOnHover};
  }

  &:active {
    background: ${props =>
      props.theme.themeColors.zoomButtons.backgroundOnActive};
    border: 1px solid
      ${props => props.theme.themeColors.zoomButtons.borderColorOnActive};
  }
`;
